// extracted by mini-css-extract-plugin
module.exports = {"title":"index-module--title--3plJQ","box":"index-module--box--3-7e3","sub":"index-module--sub--3qlaS","right":"index-module--right--3LBOR"};